import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers, Enums } from "@shared";
import { AutoPay, PaymentDay } from ".";
import { DateTime } from "luxon";

const PaymentAutopay = () => {

    const navigate = useNavigate(), location = useLocation();
    const {
        state:
        {
            makePayment,
            account,
            currentBill: { dueDate, idProductType },
        }
    } = location;
    const {
        orgDays,
        paymentPreferences: { defaultPaymentMethod },
        accountPreferences,
        safeToday
    } = account;
    const { dueDay: payorDueDay } = accountPreferences;

    useEffect(() => {
        (async () => {
            const { autodrawDay } = helpers.getDaysFromPayor(orgDays, payorDueDay);
            setSelectedDueDay(autodrawDay);
        })();
    }, []);

    const { locked, maxDay } = helpers.getDaysFromPayor(orgDays, payorDueDay);

    const [autoPay, setAutoPay] = useState(true);
    const [selectedDueDay, setSelectedDueDay] = useState(payorDueDay ?? 1);


    const actionClick = () => {

        if (autoPay) {
            const autoPayDate = helpers.compoundDay(dueDate, selectedDueDay);

            const todayDay = DateTime.fromISO(safeToday);
            const isAutopayLate = todayDay.diff(autoPayDate, `days`).days >= 0;

            helpers.navigateNext(location, navigate, {
                isAutoPay: autoPay,
                makePayment: false,
                isAutopayLate
            }, {
                account: { ...account, accountPreferences: { ...accountPreferences, isAutopay: autoPay, dueDay: selectedDueDay } }
            });
        } else {
            helpers.navigateNext(location, navigate);
        }
    };

    const cancel = () => {
        helpers.navigateNext(location, navigate, { cancel: true });
    };

    const btnText = autoPay ? `Continue` : `Make one-time payment`;

    return (
        <div className="flex flex-col bg-white p-6 w-full rounded-b-lg gap-y-5 min-h-sb pb-12 items-center">
            <div className="flex flex-col gap-y-3">
                <h1 className="text-center font-bold text-2xl">Turn on auto-pay</h1>
                <span className="text-center text-lg">By clicking <b>Continue</b> you are authorizing Sunbound to debit your account for your total monthly balance on your payment date</span>
            </div>
            <AutoPay setAutoPay={setAutoPay} autoPay={autoPay} paymentMethod={defaultPaymentMethod} />
            {
                autoPay &&
                <div className="p-3 mt-5 w-full text-justify text-lg space-y-3">
                    {
                        idProductType === Enums.ProductType.Gateway &&
                        <span className="text-lg">We will schedule your auto-pay based on your community&apos;s due day</span>
                    }
                    {
                        idProductType === Enums.ProductType.SunboundPay &&
                        <span className="text-lg">Select a date for your auto-pay</span>

                    }
                    <PaymentDay dueDay={selectedDueDay} setDueDay={setSelectedDueDay} locked={locked} maxDay={maxDay} />
                </div>
            }
            {
                (autoPay || !autoPay && makePayment) &&
                <button type="button" className="btn btn-primary text-xl mt-3 rounded-full" onClick={actionClick}>{btnText}</button>
            }
            {
                !autoPay && !makePayment &&
                <button type="button" className="btn btn-primary text-xl mt-3 rounded-full" onClick={cancel}>Back</button>
            }
        </div >

    );
};

export default PaymentAutopay;
